import React from 'react';
import PropTypes from 'prop-types';

const OrderStatusBadge = ({ status }) => {
  const getStatusConfig = (status) => {
    switch(status) {
      case 'APPROVED':
        return { label: 'Aprobada', className: 'confirmed' };
      case 'REJECTED':
        return { label: 'Denegada', className: 'cancelled' };
      case 'CANCELLED':
        return { label: 'Anulada', className: 'cancelled' };
      case 'REFUND':
        return { label: 'Reembolsada', className: 'refunded' };
      case 'WAITING_CONFIRMATION':
        return { label: 'Esperando aprobación', className: 'waiting' };
      default:
        return { label: 'Pendiente', className: 'completed' };
    }
  };

  const { label, className } = getStatusConfig(status);

  return (
    <span className={`order-status-badge ${className}`}>
      {label}
    </span>
  );
};

OrderStatusBadge.propTypes = {
  status: PropTypes.string.isRequired
};

export default OrderStatusBadge; 